module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['row', 'block-other-regions', _vm.sub_class]
  }, [(_vm.title) ? _c('div', {
    staticClass: "col-l-12 col-m-12 col-s-12"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "location location-info"
  }, [_c('h2', {
    staticClass: "location-info__title light"
  }, [_vm._v(_vm._s(_vm.title))])])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.other_regions), function(region, index) {
    return _c('div', {
      key: index,
      staticClass: "col-l-4 col-m-4 col-s-12 region-block"
    }, [_c('div', {
      staticClass: "container"
    }, [_c('a', {
      attrs: {
        "href": region.link.url,
        "target": region.link.target
      }
    }, [_c('div', {
      staticClass: "col-s-12"
    }, [_c('img', {
      attrs: {
        "src": region.image.url
      }
    }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(region.title))])])])])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-026c7e2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlockOtherRegions.vue
// module id = 306
// module chunks = 0